import OPTIONS from './options'

export const getDateWithRequestDelay = (time: string | number, timeOffset = OPTIONS.timeOffset): Date => new Date(Number(new Date(time)) + OPTIONS.requestDelay + timeOffset);
export const getDate = (time: string | number, timeOffset = OPTIONS.timeOffset): Date => new Date(Number(new Date(time)) + timeOffset);
